



























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import Picture from '@/components/atoms/Picture/Picture.vue';
import CheckIcon from '@/components/icons/Check.vue';

@Component({
  components: {
    Picture,
    CheckIcon
  }
})
export default class BusinessItem extends Vue {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop() readonly business: any;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get loggedBusiness() {
    return this.business.id === this.businessInfo.id;
  }

  @Emit('select')
  onSelect() {
    return this.business;
  }
}
